import { addTransformUtils } from '@/utils/formHelpers';

export default function parseUrl(searchOptions, router) {
  const formattedQueryGroup = {};
  const { query: queryGroup, asPath: url } = router;

  const hasQueryInitializer = url.indexOf('?') > -1;

  if (!hasQueryInitializer) {
    return {};
  }

  const queryKeys = Object.keys(queryGroup);

  queryKeys.forEach(k => {
    const _k = k.toLowerCase();
    switch (_k) {
      case 'states':
        formattedQueryGroup.States = queryGroup[k].split(',');
        break;
      case 'charts':
        formattedQueryGroup.Charts = queryGroup[k].split(',');
        break;
      case 'categories':
        formattedQueryGroup.Categories = queryGroup[k].split(',');
        break;
      case 'searchtext':
        formattedQueryGroup.SearchText = queryGroup[k];
        break;
      case 'datestart':
        formattedQueryGroup.DateStart = queryGroup[k];
        break;
      case 'dateend':
        formattedQueryGroup.DateEnd = queryGroup[k];
        break;
      default:
        break;
    }
  });

  if (formattedQueryGroup.Charts) {
    formattedQueryGroup.Charts = formattedQueryGroup.Charts.map(id => Number(id));
  }
  if (formattedQueryGroup.Categories) {
    formattedQueryGroup.Categories = formattedQueryGroup.Categories.map(id => Number(id));
  }

  const copyFieldOptions = addTransformUtils(formattedQueryGroup, searchOptions);

  queryKeys.forEach(k => {
    switch (k) {
      case 'states':
        formattedQueryGroup.States = copyFieldOptions.getFullComplex('States', 'StateCode');
        return formattedQueryGroup;
      case 'charts':
        formattedQueryGroup.Charts = copyFieldOptions.getFullComplex('Charts', 'ChartId');
        return formattedQueryGroup;
      case 'categories':
        formattedQueryGroup.Categories = copyFieldOptions.getFullComplex(
          'Categories',
          'CategoryId'
        );
        return formattedQueryGroup;
      default:
        return formattedQueryGroup;
    }
  });
  // console.log({formattedQueryGroup})

  // eslint-disable-next-line consistent-return
  return formattedQueryGroup;
}
